import React, {useEffect, useState} from 'react';
import {Box, Button, Modal, Typography} from '@mui/material';
import Header from "../components/Header";
import SessionStatus from '../components/SessionStatus';
import History from '../components/History';
import apiService from "../services/api";
import {DotLoader} from "react-spinners";
import {useNavigate} from "react-router-dom";

// Main component
const MainPage = ({user, setUser}) => {
    const [loadingHistory, setLoadingHistory] = useState(true);
    const [historyItems, setHistoryItems] = useState([]);
    const [todayMeetingMetadata, setTodayMeetingMetadata] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loadingCreateSession, setLoadingCreateSession] = useState(false);
    const navigate = useNavigate();

    const loadHistory = async () => {
        setLoadingHistory(true);
        const historyItems = await apiService.getConversationsMetadata();
        const todayConvoMetadata = historyItems.find(item => {
            return new Date(item.startTime).toLocaleDateString() === new Date().toLocaleDateString()
        });
        setTodayMeetingMetadata(todayConvoMetadata);
        setHistoryItems(historyItems);
        setLoadingHistory(false);
    };

    useEffect(() => {
        loadHistory();
    }, []);


    const constNavigateToChat = (sessionId) => {
        navigate(`/chat/${sessionId}`, {replace: true});
    }

    const handleStartMeeting = () => {
        setIsModalOpen(true); // Open the modal when meeting starts
    };

    const handleCloseModal = () => {
        setIsModalOpen(false); // Close the modal
    };

    const handleCreateMeeting = async () => {
        setIsModalOpen(false);
        setLoadingCreateSession(true);
        const session = await apiService.startSession();
        console.log(session);
        if (session) {
            setLoadingCreateSession(false);
            navigate(`/chat/${session.sessionId}`, {replace: true});
            loadHistory();
        }
    }

    return (
        <Box sx={{
            backgroundColor: '#181828',
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            position: 'relative',
            direction: 'rtl',
            color: 'white',
        }}>
            <Header setUser={setUser} user={user}/>

            {/* Session Status Component */}
            {loadingHistory ?
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                }}>
                    <DotLoader color={'#00ad9f'} loading={loadingHistory}/>
                </Box>
                : <SessionStatus
                    todayMeetingMetadata={todayMeetingMetadata}
                    handleStartMeeting={handleStartMeeting}
                />
            }

            {/* History Component */}
            <History
                isLoading={loadingHistory}
                historyItems={historyItems}
            />

            {/* Modal for session start confirmation */}
            <Modal
                open={isModalOpen}
                onClose={handleCloseModal}
                aria-labelledby="start-meeting-title"
                aria-describedby="start-meeting-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: {xs: '90%', sm: '400px'},
                    bgcolor: '#1c1c2e',
                    color: 'white',
                    borderRadius: '12px',
                    boxShadow: 24,
                    p: 3,
                    textAlign: 'center',
                    direction: 'rtl',
                }}>
                    {/* Modal Title */}
                    <Typography
                        id="start-meeting-title"
                        variant="h6"
                        component="h2"
                        sx={{
                            mb: 2,
                            fontWeight: 'bold',
                            fontSize: '1.2rem',
                            background: 'linear-gradient(45deg, #693e86, #34929a)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent'
                        }}
                    >
                        התחלת הפגישה היומית
                    </Typography>

                    {/* Modal Description */}
                    <Typography
                        id="start-meeting-description"
                        sx={{
                            mb: 3,
                            fontSize: '0.9rem',
                            color: '#e0e0e0'
                        }}
                    >
                        שים לב שאורך הפגישה מוגבל ל 20 דקות, ולאחר שתתחיל לא תוכל לעצור את הפגישה באמצע.
                    </Typography>

                    {/* Buttons */}
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: 2
                    }}>
                        <Button
                            variant="outlined"
                            onClick={handleCloseModal}
                            sx={{
                                color: 'white',
                                borderColor: '#6e00b7',
                                padding: '10px 30px',
                                borderRadius: 8,
                                '&:hover': {
                                    borderColor: '#0093e9',
                                    color: '#00a3b1'
                                }
                            }}
                        >
                            לא עכשיו
                        </Button>
                        <Button
                            variant="contained"
                            onClick={handleCreateMeeting}
                            sx={{
                                background: 'linear-gradient(45deg, #00a3b1, #0093e9, #6e00b7)',
                                color: 'white',
                                padding: '10px 30px',
                                borderRadius: 8,
                                boxShadow: '0px 3px 5px 2px rgba(110, 0, 183, 0.3)',
                                '&:hover': {
                                    background: 'linear-gradient(45deg, #6e00b7, #0093e9, #00a3b1)'
                                }
                            }}
                        >
                            אני מוכן
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </Box>
    );
};

export default MainPage;
